import type { TFunction } from 'i18next';

/** Translate domain enum codes shown in UI (keeps API values as-is). */
export function enumLabel(t: TFunction, group: string, code: string | null | undefined): string {
  if (!code) return '—';
  const key = `enums.${group}.${code}`;
  const translated = t(key);
  return translated === key ? code : translated;
}
